import React from 'react';
import { Link } from 'react-router-dom';
import './Day2Apps.css';

// Import images for add-ons (adapt from Vue require paths)
import externalDnsIcon from '../Public/Images/external-dns.png';
import keycloakIcon from '../Public/Images/keycloak.png';
import certManagerIcon from '../Public/Images/cert-manager.png';
import harborIcon from '../Public/Images/harbor.png';
import grafanaIcon from '../Public/Images/grafanaNoBackground.png';
import argoCdIcon from '../Public/Images/argo.png';
import clusterAutoscalerIcon from '../Public/Images/cluster-autoscaler.png';
import karpenterIcon from '../Public/Images/karpenter.png';
import nginxIcon from '../Public/Images/nginx.png';
import veleroIcon from '../Public/Images/velero.png';
import albControllerIcon from '../Public/Images/alb-controller.png';
import openCostIcon from '../Public/Images/opencost.png';
import storageClassIcon from '../Public/Images/cluster-autoscaler.png';

// Import screenshots (assume placed in public/images)
import day2GridScreenshot from '../Public/Images/day2GridScreenshot.png';
import helmConfigScreenshot from '../Public/Images/helmConfigScreenshot.png';

function Day2Apps() {
    return (
        <div className="day2apps-page">
            <section className="hero-section">
                <div className="hero-content">
                    <h1>Day 2 Ops: Continuous operations with compliance built in.</h1>
                    <p>With VitroAI™, you don’t just deploy infrastructure — you operate it confidently. Security, observability, and audit readiness are pre-integrated so compliance is faster, cheaper, and simpler.</p>
                </div>
            </section>
            <section className="apps-section">
                <h2>Available Day 2 Applications</h2>
                <div className="apps-container">
                    <div className="app">
                        <img src={externalDnsIcon} alt="External-DNS" className="app-icon" />
                        <h3>External-DNS</h3>
                        <p>Automates DNS record management for Kubernetes services.</p>
                    </div>
                    <div className="app">
                        <img src={keycloakIcon} alt="Keycloak" className="app-icon" />
                        <h3>Keycloak</h3>
                        <p>Provides identity and access management for secure authentication.</p>
                    </div>
                    <div className="app">
                        <img src={certManagerIcon} alt="Cert-Manager" className="app-icon" />
                        <h3>Cert-Manager</h3>
                        <p>Manages TLS certificates for Kubernetes applications.</p>
                    </div>
                    <div className="app">
                        <img src={harborIcon} alt="Harbor" className="app-icon" />
                        <h3>Harbor</h3>
                        <p>Cloud-native registry for storing and scanning container images.</p>
                    </div>
                    <div className="app">
                        <img src={grafanaIcon} alt="Grafana" className="app-icon" />
                        <h3>Grafana</h3>
                        <p>Visualizes and analyzes metrics for monitoring.</p>
                    </div>
                    <div className="app">
                        <img src={argoCdIcon} alt="argoCD" className="app-icon" />
                        <h3>argoCD</h3>
                        <p>Enables GitOps continuous delivery for Kubernetes.</p>
                    </div>
                    <div className="app">
                        <img src={clusterAutoscalerIcon} alt="Cluster Autoscaler" className="app-icon" />
                        <h3>Cluster Autoscaler</h3>
                        <p>Scales Kubernetes clusters based on workload demands.</p>
                    </div>
                    <div className="app">
                        <img src={karpenterIcon} alt="Karpenter" className="app-icon" />
                        <h3>Karpenter</h3>
                        <p>Optimizes node provisioning for Kubernetes workloads.</p>
                    </div>
                    <div className="app">
                        <img src={nginxIcon} alt="Nginx" className="app-icon" />
                        <h3>Nginx</h3>
                        <p>High-performance ingress controller for Kubernetes traffic.</p>
                    </div>
                    <div className="app">
                        <img src={veleroIcon} alt="Velero" className="app-icon" />
                        <h3>Velero</h3>
                        <p>Backs up and restores Kubernetes cluster resources.</p>
                    </div>
                    <div className="app">
                        <img src={albControllerIcon} alt="ALB-Controller" className="app-icon" />
                        <h3>ALB-Controller</h3>
                        <p>Automates the provisioning of AWS Application Load Balancers.</p>
                    </div>
                    <div className="app">
                        <img src={openCostIcon} alt="OpenCost" className="app-icon" />
                        <h3>OpenCost</h3>
                        <p>open-source tool that tracks and allocates Kubernetes workload costs in real time.</p>
                    </div>
                    <div className="app">
                        <img src={storageClassIcon} alt="Storage-Class" className="app-icon" />
                        <h3>Storage-Class</h3>
                        <p>Enables customizable storage classes for dynamic provisioning in Kubernetes, supporting various storage backends like AWS EBS with configurable performance and access modes.</p>
                    </div>
                </div>
            </section>
            <section className="interface-section">
                <h2>Our Day 2 Apps Interface in FKP Platform™</h2>
                <p>The FKP platform™ features a user-friendly panel for installing, editing, and managing Day 2 add-ons. Below are screenshots of the interface in action.</p>
                <div className="interface-images">
                    <div className="screenshot-container">
                        <img src={day2GridScreenshot} alt="Day 2 Add-ons Grid" className="screenshot-image" />
                        <p className="image-caption">Day 2 Add-ons Selection and Deployment Grid</p>
                    </div>
                    <div className="screenshot-container">
                        <img src={helmConfigScreenshot} alt="Helm Values Configuration" className="screenshot-image" />
                        <p className="image-caption">Helm Values Configuration Dialog for Add-on Editing</p>
                    </div>
                </div>
            </section>
            <section className="cta-section">
                <h2>Day 2 Confidence — because running in production is just the beginning.</h2>
                <p>Stay compliant, cost-efficient, and resilient with Federal Frontier Day 2 Applications in the FKP Platform™.</p>
                <Link to="/contact" className="learn-more-button-day2apps">Explore Day 2 Solutions</Link>
            </section>

            {/* Page-specific CTA that enforces the light blue in light mode and dark section color in dark mode */}
            <section className="cta-section-day2apps">
                <h2>Day 2 Confidence — because running in production is just the beginning.</h2>
                <p>Stay compliant, cost-efficient, and resilient with Federal Frontier Day 2 Applications in the FKP Platform™.</p>
                <Link to="/contact" className="learn-more-button-day2apps">Explore Day 2 Solutions</Link>
            </section>
         </div>
     );
 }

 export default Day2Apps;
